import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Router} from '@angular/router';
import {
  AvailableSimTypes,
  SimType,
  StepData
} from 'models';
import { debounceTime, filter, first, take } from 'rxjs/operators';
import { ModalType } from '../../../../../../app-shared/models/modal.interface';
import { SimTypeEnum, SimTypeType } from '../../../../../../app-shared/models/steps/step-sim.interface';
import { SimTypeTypes } from '../../../constants/sim.constants';
import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-sim-type',
  templateUrl: './sim-type.component.html',
  styleUrls: ['./sim-type.component.scss']
})
export class SimTypeComponent extends ProcessStepBaseComponent implements OnInit, OnDestroy {
  public availableSimTypes: SimTypeType[] = [];
  simTypeESIMForm;
  simTypes = SimTypeTypes;
  private returnUrl = '/';

  constructor(injector: Injector, private router: Router) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepSimTypeForm());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepSimTypeValue);
    this.getFormDataAndValidation();
    this.simTypeESIMForm = new FormGroup({
      // confirm: new FormControl(undefined, Validators.requiredTrue)
    });
    this.appStoreFacadeService.entity.funnelInfo$
      .pipe(take(1))
      .subscribe((funnelInfo) => {
        if (funnelInfo && funnelInfo.returnUrl) {
          this.returnUrl = funnelInfo.returnUrl;
        }
      });
    window.addEventListener('popstate', this.handleBackButton);
  }

  private handleBackButton = () => {
    if (this.returnUrl.startsWith('http')) {
      window.location.href = this.returnUrl;
    } else {
      this.router.navigateByUrl(this.returnUrl);
    }
  }

  public goToPreviousStep() {
    this.router.navigateByUrl(this.returnUrl);
  }

  public onSimTypeChange(selectedSimType: string) {
    this.formGroup.patchValue({ simType: { type: selectedSimType } });
    this.formGroup.get('simType').markAsTouched();
    setTimeout(() => {
      this.goToNextStep();
    }, 200);
  }

  public goToNextStep() {
    if (this.simTypeESIMForm.invalid) {
      this.markFormAsDirtyAndScrollToError(undefined, this.simTypeESIMForm);
      return;
    }
    super.goToNextStep();
  }

  get isSimTypeInvalid() {
    const simTypeGroup = this.formGroup.get('simType');
    return simTypeGroup.touched && simTypeGroup.invalid;
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.entity.availableSimTypes$
        .pipe(first(Boolean))
        .subscribe(({ types }: AvailableSimTypes) => {
          this.availableSimTypes = this.simTypes.filter(type => {
            return types.includes(type.id as SimTypeEnum);
          });
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.simType$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.simTypeValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          // Set default
          if (!this.formGroup.value.simType.method && this.availableSimTypes.length) {
            this.formGroup.patchValue({ simType: { type: this.availableSimTypes[0].id } });
          }
          this.sendAnalyticsData();
        })
    );

    this.subscriptions.add(
      this.formGroup.get('simType').valueChanges
        .pipe(filter(Boolean))
        .subscribe((value: SimType) => {
          if (value.type === SimTypeEnum.eSim) {
            this.simTypeESIMForm.enable();
          } else {
            this.simTypeESIMForm.disable();
          }
        })
    );
  }

  simTypeGenericpopup() {
    this.appStoreFacadeService.modals
      .openModal(ModalType.Generic, {
        title: 'ENTITY.SIM-TYPE.MODEL-TITLE',
        message: 'ENTITY.SIM-TYPE.MODEL-DESCRIPTION',
      });
  }

  showCompatibleDevices(event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.subscriptions.add(
      this.appStoreFacadeService.modals.esimModalResult$
        .pipe(first())
        .subscribe(result => {
          if (result) {
            if (result.action === SimTypeEnum.Standard) {
              this.proceedWithPhysicalSim();
            } else if (result.action === SimTypeEnum.eSim) {
              this.proceedWithESim();
            }
          }
        })
    );
    this.appStoreFacadeService.modals.openESimMultistepCompatibleDevicesModal('sim-type');
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.handleBackButton);
  }

  proceedWithPhysicalSim() {
    this.formGroup.get('simType.type').setValue(SimTypeEnum.Standard);
    this.goToNextStep();
  }

  proceedWithESim() {
    this.formGroup.get('simType.type').setValue(SimTypeEnum.eSim);
    this.goToNextStep();
  }
}

